import { styled } from 'stitches.config'

export const DescriptionRoot = styled('div', {
  ul: {
    display: 'flex',
    flexDirection: 'column',
    gap: '$1',
  },
})
